<style type="text/css">
  table {
    border-collapse: collapse;
  }

  table, th, td {
    border: 1px solid black;
    padding: 4px;
    text-align: center;
  }

  tr.processed {
    background-color: lightgreen;
  }
</style>

<div>
  <button class="float-right" (click)="checkPackage(0)" [disabled]="goButtonDisabled">Start Checking</button>
  <table>
    <thead>
      <tr>
        <th>Received Date</th>
        <th>From Name</th>
        <th>Requisition Count</th>
        <th>Already Sent</th>
        <th>Successfully Sent</th>
        <th>Unsuccessful</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let package of packages" [class.processed]="package.RequisitionCount != 0">
        <td>{{package.ReceivedDate | date:'short'}}</td>
        <td>{{package.FromName}}</td>
        <td>{{package.RequisitionCount}}</td>
        <td>{{package.AlreadySent}}</td>
        <td>{{package.SuccessfullySent}}</td>
        <td>{{package.Unsuccessful}}</td>
      </tr>
    </tbody>
  </table>
</div>
